module.exports = __webpack_public_path__ + "img/certasslogo.8170ddce.png";